import "./Item.scss";
import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";

export default function Item(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <div className={"item " + (props.isNew && "item--new") + " " + (props.InStock && "item--stock")}>
      <div className="item__row">
        <div className="item__title">
          <Link to={props.inside}>
            <span className="title">{props.title}</span>
          </Link>
          <span className="item__new-arr">НОВИНКА!</span>
        </div>
        <div className="item__wrapper">
          <div className="item__image-container">
            {props.imgUrl}
          </div>
          <div className="item__center">
            <div className="item__block">
              <span className="item__factory-text">Виробник:</span>
              <span className="item__factory-name">{props.producer}</span>
            </div>
            <div className="item__zone">
              <div className="item__packing">
                <span className="item__packing-text">Фасування:</span>
                <div className="item__packing_double-position">
                  <div className="item__capacity-tabs">
                    <button className={toggleState === 1 ? "itemCard__cap-tabs active-itemCard__cap-tabs" : "itemCard__cap-tabs"}
                      onClick={() => toggleTab(1)}>
                      {props.containerFirst}
                    </button>
                    <button className={toggleState === 2 ? "itemCard__cap-tabs active-itemCard__cap-tabs" : "itemCard__cap-tabs"}
                      onClick={() => toggleTab(2)}>
                      {props.containerSecond}
                    </button>
                    {props.containerThird && (
                      <button className={toggleState === 3 ? "itemCard__cap-tabs active-itemCard__cap-tabs" : "itemCard__cap-tabs"}
                        onClick={() => toggleTab(3)}>
                        {props.containerThird}
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="item__price">
                <div className="price__charts">
                  <span className="price__item">Роздрібна ціна</span>
                </div>
                <div className="price item__capacity-tabs-active">
                  <div
                    className={
                      toggleState === 1 ? "capacity  active-capacity" : "capacity"
                    }
                  >
                    {props.priceFirst}
                  </div>

                  <div
                    className={
                      toggleState === 2 ? "capacity  active-capacity" : "capacity"
                    }
                  >
                    {props.priceSecond}
                  </div>

                  {props.priceThird && (
                    <div
                      className={
                        toggleState === 3 ? "capacity  active-capacity" : "capacity"
                      }
                    >
                      {props.priceThird}
                    </div>
                  )}

                </div>
                <div className={"item__stock " + (props.InStock && 'item__stock--new')}>
                  <span className="item__stock-arr">в наявності</span>
                  <span className="item__stock-road">товар в дорозі</span>
                </div>
                <div className="item__suborder">
                  <div className="item__order">
                    {props.link}
                  </div>
                  <Link to={props.inside}>
                    <p className="item__desc">Детальніше</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
